import * as OFMSUI from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Field, useFormik, FormikProvider, ErrorMessage } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { generatePDF, LabelHeader, ModuleHeaderTitle, NumberValidation } from "../../utils/commonFunctions";
import { store } from "../../../App";
import ShowAlert from "../../alert";
import { AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Link } from "@material-ui/core";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const SubHeadsOpeningBalance = () => {
    const history = useHistory();

    const [openingBalanceDataSubhead, setOpeningBalanceSubhead] = useState([]);

    const [searchSubhead, setSearchSubhead] = useState("");

    const [selectedCheckboxesSubhead, setSelectedCheckboxesSubhead] = useState([]);

    const [selectedListSubhead, setSelectedListSubhead] = useState([]);

    const [showSubHeadsTable, setShowSubHeadsTable] = useState(false);

    const [totalCredit, setTotalCredit] = useState(0);
    const [totalDebit, setTotalDedit] = useState(0);
    const [headNamesList, setheadNamesList] = useState([]);
    const [saveHeadid, setSaveHeadId] = useState("");

    const validationSchema = Yup.object().shape({
        headtype: Yup.string().required("headtype is required"),
        headid: Yup.string().required("headid is required"),
    });

    const formik = useFormik({
        initialValues: {
            headtype: "",
            headid: "",
            rowsSubhead: [{
                creditSubhead: '',
                debitSubhead: '',
                checkingSubhead: false,

            }]
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setSaveHeadId(values.headid)
            submitAction();
        }
    });

    const submitAction = async () => {
        setSelectedCheckboxesSubhead([]);
        setSelectedListSubhead([]);

        formik.setFieldValue(
            "rowsSubhead",
            formik.values.rowsSubhead.map(rowSub => ({
                ...rowSub,
                creditSubhead: "",
                debitSubhead: "",
                checkingSubhead: false
            }))
        );

        const params = { headid: formik.values.headid };
        store.dispatch({ type: "SHOW_SPINNER" });

        try {
            const debitCreditRes = await HousingService.getHeadidDebitCredit(params);

            if (debitCreditRes?.data?.length > 0) {
                setTotalDedit(debitCreditRes.data[0].debit || 0);
                setTotalCredit(debitCreditRes.data[0].credit || 0);
            } else {
                setTotalDedit(0);
                setTotalCredit(0);
            }

            const res = await HousingService.getSubheads(params);

            if (res?.data?.length > 0) {
                setOpeningBalanceSubhead(res.data);

                formik.setValues({
                    ...formik.values,
                    rowsSubhead: res.data.map(item => ({
                        creditSubhead: item.credit ?? "",
                        debitSubhead: item.debit ?? "",
                        checkingSubhead: false
                    }))
                });
            } else {
                setOpeningBalanceSubhead([]);
                formik.setFieldValue("rowsSubhead", []);
            }

        } catch (error) {
            console.error("Subhead API Error:", error);
            ShowAlert("Some Error Occurred", "error");
        } finally {
            store.dispatch({ type: "HIDE_SPINNER" });
            setShowSubHeadsTable(true);
        }
    }

    const handleSearchSubhead = event => { setSearchSubhead(event.target.value) }

    const filteredDataSubhead = searchSubhead.length > 0 ? openingBalanceDataSubhead?.filter((item) => {
        return (
            item && Object.keys(item).some((key) => {
                const value = item[key];
                return (
                    value !== null && value.toString().toLowerCase().includes(searchSubhead.toLowerCase()));
            }));
    }) : openingBalanceDataSubhead;






    const handleCheckboxChangeSubhead = (event, detail, i) => {
        const selectedSubhead = event.target.checked;
        setSelectedCheckboxesSubhead((prevSelectedCheckboxes) => {
            if (selectedSubhead) {
                return [...prevSelectedCheckboxes, detail.subheadseqid];
            } else {
                return prevSelectedCheckboxes.filter((value) => value !== detail.subheadseqid);
            }
        });
        setSelectedListSubhead((prevList) => {
            if (selectedSubhead) {
                return [
                    ...prevList,
                    {
                        headid: detail.headid,
                        subheadid: detail.subheadid,
                        subheadseqid: detail.subheadseqid,
                        subheadname: detail.subheadname,
                        credit: parseFloat(formik.values.rowsSubhead[i]?.creditSubhead),
                        debit: parseFloat(formik.values.rowsSubhead[i]?.debitSubhead),
                    },
                ];
            } else {
                return prevList.filter((value) => value.subheadseqid !== detail.subheadseqid);
            }
        });
    };






    const submitListSubhead = () => {
        if (selectedListSubhead.length === 0) {
            ShowAlert("Please select at least one checkbox", "warning");
            return;
        }
        console.log("selectedListSubhead", selectedListSubhead);
        console.log("Headid Credit Limit:", totalCredit);
        console.log("Headid Debit Limit:", totalDebit);

        // Calculate total credit and debit
        const creditSum = formik.values.rowsSubhead.reduce((sum, item) => sum + Number(item.creditSubhead || 0), 0);
        const debitSum = formik.values.rowsSubhead.reduce((sum, item) => sum + Number(item.debitSubhead || 0), 0);

        console.log("Submitted creditSum:", creditSum);
        console.log("Submitted debitSum:", debitSum);

        // Validate limits

        if (debitSum > totalDebit) {
            ShowAlert("Total Subhead Debit amount cannot exceed the Head Debit limit.", "warning");
            setSelectedListSubhead([]);
            setSelectedCheckboxesSubhead([]);
            return;
        }

        if (creditSum > totalCredit) {
            ShowAlert("Total Subhead Credit amount cannot exceed the Head Credit limit.", "warning");
            setSelectedListSubhead([]);
            setSelectedCheckboxesSubhead([]);
            return;
        }

        Swal.fire({
            text: "Are you sure you want to submit?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (!result.isConfirmed) return;
            store.dispatch({ type: "SHOW_SPINNER" });
            HousingService.insertopeneningBalanceSubHeadsData(selectedListSubhead).then((res) => {
                const { responseToken, responseMessage } = res.data;
                if (responseToken === "1") {
                    ShowAlert(responseMessage, "success").then((isConfirm) => {
                        if (isConfirm.value) {
                            submitAction();
                        }
                    });
                } else {
                    ShowAlert(responseMessage, "error");
                }
            }).catch(() => {
                ShowAlert("Some error occurred", "error");
            }).finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
            });
        });
    };

    const HeadsOpeningBalanceBack = () => {
        history.goBack();

    }


    const fetchOBMasterHeads = (e) => {
        store.dispatch({ type: "SHOW_SPINNER" });
        formik.setFieldValue("headid", "");
        if (e.target.value != "") {
            let params = { headType: e.target.value }
            HousingService.OBMasterHeads(params).then((res) => {
                if (res.data) {
                    let options = res.data.map((item, i) => {
                        return (<option key={i} value={item.headid}> {item.heads} </option>);
                    });
                    setheadNamesList(options);
                }
            }).finally(() => {
                store.dispatch({ type: "HIDE_SPINNER" });
            });
        }
        else {
            setheadNamesList([]);
        }

    }
    return (
        <>
            <NavigationServicesHeader />
            <OFMSUI.Container fluid style={{ width: "90%" }}>
                <OFMSUI.Row>
                    <ModuleHeaderTitle title="Subheads Opening Balance as on 01-04-2022" />
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                        <button className="btn btn-primary" style={{ textAlign: "right", float: "right", marginTop: "30px" }} type="button" onClick={() => HeadsOpeningBalanceBack()} > Back </button>
                    </OFMSUI.Col>
                </OFMSUI.Row>
            </OFMSUI.Container>

            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                        <OFMSUI.Row className="mb-3">
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                                <LabelHeader title="Head type" />
                                <Field component="select" name="headtype" className={formik.touched.headtype && formik.errors.headtype ? "form-control is-invalid" : "form-control"}
                                    onChange={(e) => { formik.handleChange(e); fetchOBMasterHeads(e) }}
                                >
                                    <option value="">Select</option>
                                    <option value="3%">Liabilities</option>
                                    <option value="4%">Assets</option>
                                </Field>
                                <ErrorMessage name="headtype" component={"div"} className="text-error" />
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="" >
                                <LabelHeader title="Head ID" />
                                <Field component="select" name="headid" className={formik.touched.headid && formik.errors.headid ? "form-control is-invalid" : "form-control"} >
                                    <option value="">Select</option>
                                    {headNamesList}
                                </Field>
                                <ErrorMessage name="headid" component={"div"} className="text-error" />
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className="mb-3">
                                <div className="d-grid mt-2">
                                    <button type="submit" className="btn btn-success btn-sm mt-3">
                                        Get Details
                                    </button>
                                </div>
                            </OFMSUI.Col>
                        </OFMSUI.Row>
                        {showSubHeadsTable && (<>
                            <div style={{ textAlign: "center", justifyContent: "space-evenly", }}>
                                <h5>
                                    <span>
                                        <strong>  Head ID:</strong>{" "}
                                        <span style={{ color: "#0d6efd" }}>  {(saveHeadid).toLocaleString("en-IN")}</span>
                                    </span>

                                    <span>
                                        <strong>  Debit Amount:</strong>{" "}
                                        <span style={{ color: "#dc3545" }}>  {(totalDebit).toLocaleString("en-IN")}</span>
                                    </span>

                                    <span>
                                        <strong>  Credit Amount:</strong>{" "}
                                        <span style={{ color: "#198754" }}>  {(totalCredit).toLocaleString("en-IN")}</span>
                                    </span>
                                </h5>
                            </div>
                            <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=' mb-3' > <div className='input-group'> <div className='input-group-prepend'> <div className='input-group-text group_txt11' id='btnGroupAddon' > <AiOutlineSearch /> </div> </div> <input type='text' id='#filterInput' placeholder='Search ' style={{ width: '25%' }} className='form-control input-lg' value={searchSubhead} onChange={handleSearchSubhead} ></input> </div> </OFMSUI.Col>
                                <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=' mb-2 float-end' >
                                    <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', marginLeft: '3px' }} > <ReactHTMLTableToExcel id='my-table-xls-button' className='download-table-xls-button' table='my-tablesub' filename='SubHeadsOpeningBalance' sheet='tablexls' buttonText='Excel' /> </button>
                                    <button className='btn btn-danger btn-sm' type='button' style={{ float: 'right', marginLeft: '3px' }}
                                        onClick={() => generatePDF("my-tablesub", "Sub Heads Opening Balance as on 01-04-2024", "SubHeadsOpeningBalance.pdf", 5)}> PDF <MdOutlinePictureAsPdf /> </button>
                                </OFMSUI.Col>
                            </OFMSUI.Row>
                            <div style={{ overflow: "auto", height: "600px" }}>
                                <Table striped bordered hover id="my-tablesub" style={{ width: "100%" }}>
                                    <thead className="fw-bold" style={{ top: "0px", position: "sticky" }}>
                                        <tr className="table_countshead">
                                            <th className="text-center">S.No.</th>
                                            <th>Sub Head ID</th>
                                            <th>Sub Head Name</th>
                                            <th>Debit</th>
                                            <th>Credit</th>
                                            <th style={{ textAlign: "center" }}>Check</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredDataSubhead?.length === 0 || filteredDataSubhead === undefined ? (
                                            <tr>
                                                <td colSpan={6} style={{ fontSize: "15px", textAlign: "center" }}>
                                                    No Subheads found
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredDataSubhead.map((detail) => {
                                                const originalIndex = openingBalanceDataSubhead.findIndex(d => d.subheadseqid === detail.subheadseqid)
                                                return (
                                                    <tr key={originalIndex}>
                                                        <td className="text-center">{originalIndex + 1}</td>
                                                        <td>{detail.subheadid}</td>
                                                        <td>{(detail?.subheadname ?? "").toUpperCase()}</td>
                                                        <td className="text-right">
                                                            <Field
                                                                type="text"
                                                                name={`rowsSubhead[${originalIndex}].debitSubhead`}
                                                                className="form-control input-lg"
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`rowsSubhead[${originalIndex}].debitSubhead`, e.target.value);
                                                                    formik.setFieldValue(`rowsSubhead[${originalIndex}].creditSubhead`, e.target.value ? "0" : formik.values.rowsSubhead[originalIndex].creditSubhead);

                                                                }}
                                                                onKeyPress={(e) => NumberValidation(e)}
                                                                maxLength={15}
                                                                readOnly={detail.status != "insert"}

                                                            />
                                                        </td>
                                                        <td className="text-right">
                                                            <Field
                                                                type="text"
                                                                name={`rowsSubhead[${originalIndex}].creditSubhead`}
                                                                className="form-control input-lg"
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`rowsSubhead[${originalIndex}].creditSubhead`, e.target.value);
                                                                    formik.setFieldValue(`rowsSubhead[${originalIndex}].debitSubhead`, e.target.value ? "0" : formik.values.rowsSubhead[originalIndex].debitSubhead);
                                                                }}
                                                                onKeyPress={(e) => NumberValidation(e)}
                                                                maxLength={15}
                                                                readOnly={detail.status != "insert"}
                                                            />
                                                        </td>
                                                        <td style={{ textAlign: "center" }}>
                                                            {detail.status === "insert" ? (
                                                                <center>
                                                                    <input
                                                                        type="checkbox"
                                                                        name={`rowsSubhead[${originalIndex}].checkingSubhead`}
                                                                        value={detail.subheadseqid}
                                                                        onChange={(event) => handleCheckboxChangeSubhead(event, detail, originalIndex)}
                                                                        checked={selectedCheckboxesSubhead.includes(detail.subheadseqid)}
                                                                        disabled={
                                                                            formik.values.rowsSubhead[originalIndex]?.debitSubhead === "" ||
                                                                            formik.values.rowsSubhead[originalIndex]?.debitSubhead === null ||
                                                                            formik.values.rowsSubhead[originalIndex]?.debitSubhead === undefined ||
                                                                            formik.values.rowsSubhead[originalIndex]?.creditSubhead === "" ||
                                                                            formik.values.rowsSubhead[originalIndex]?.creditSubhead === null ||
                                                                            formik.values.rowsSubhead[originalIndex]?.creditSubhead === undefined
                                                                            // || totalCredit === totalDebit
                                                                        }
                                                                    />
                                                                </center>
                                                            ) : (
                                                                <span style={{ color: "#00AB66", fontWeight: "bold" }}>✅</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                    <tfoot style={{ bottom: "0px", position: "sticky" }}>
                                        <tr className="table_countshead">
                                            <td colSpan={3} style={{ textAlign: "right" }}> Total</td>
                                            <td>{filteredDataSubhead.reduce((a, b) => a + (b.debit || 0), 0)}</td>
                                            <td>{filteredDataSubhead.reduce((a, b) => a + (b.credit || 0), 0)}</td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </div>
                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                                <button type="button"
                                    onClick={() => submitListSubhead()}
                                    className="btn btn-success sm"> Submit </button>
                            </div>


                        </>)}

                    </OFMSUI.Container>
                </Form>
            </FormikProvider>




        </>
    )
}

export default SubHeadsOpeningBalance
